module.exports = __webpack_public_path__ + "static/media/Bonliva-care-logo.0b308992.webp";